/**
 * Google Maps JavaScript API version pinned to 3.64.
 *
 * HOTFIX (1.103.3): the DrawingManager used by MapUserDrawing was removed by
 * Google as of Maps JS API 3.65 (https://developers.google.com/maps/deprecations),
 * which blanked the location-edit map on every client. Pinning v=3.64 — the last
 * version that still ships DrawingManager — restores it.
 *
 * Temporary band-aid: Google keeps only a sliding window of recent versions, so
 * 3.64 will eventually become unavailable (~early 2027) and the bug will return.
 * Before that, migrate MapUserDrawing off DrawingManager to native
 * google.maps.Circle/Polygon and remove this pin (the "&v=" appended to every
 * useGoogleMaps()/loadGoogleMapsAPI() Maps URL).
 */
export const MAPS_API_VERSION = "3.64";

const mapDefaultParameters = {
  // Center of Brazil
  center: {
    lat: -14.235004,
    lng: -51.925280
  }
};

export default mapDefaultParameters;
